<template>
    <select class="form-select" :id="id" :name="name">
        <option selected value="0">{{TR.select}}</option>
        <template v-for="(item, index) in items" :key="index">
            <option :value="item.id" :selected="item.id == selected_id ? true : false">
                <!-- <img v-if="item.image != 'undefined'" :src="G.mediaURL + item.image" alt="" /> -->
                <!-- <div :style="item.image && item.image != 'undefined' ? `background: url('${G.mediaURL + item.image}'); width: 30px; height: 30px;` : ''"></div> -->
                {{item.title}}
            </option>
        </template>
    </select>
</template>

<script>
    import { ref, watchEffect } from "vue";

    import { useStore } from "@/store";
    import { G } from "@/_common";

    export default {
        name: 'SelectField',
        props: ["items", "selected_id", "id", "name"],
        setup() {
            const store = useStore();
            const TR = ref({});

            watchEffect(() => {
                TR.value = store.getTranslation();
            });

            return { TR, G };
        },
    };
</script>